import React, { useEffect } from "react";
import { Header, Box, Heading, Spinner } from "grommet";
import passcodeService from "@services/passcode.service";
import { AccessList } from "./GuestDetails/components";
import { useFetchHotel } from "./redux/fetchHotel";
import { useSetCurrentUser } from "./redux/hooks";
import { CustomTabs } from "@shared/CustomTabs";
import MasterPasscodes from "./MasterPasscodes";
import DoorPasscodes from "./DoorPasscodes";
import { useTranslation } from "react-i18next";
import { useFetchDoors } from "./redux/hooks";
import { supportsMasterCodes } from "../../common/masterCodes";

export default function CurrentPasscodes(props) {
  const [passcodes, setPasscodes] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const { hotel } = useFetchHotel();
  const { doors } = useFetchDoors();
  const { currentUser } = useSetCurrentUser();
  const { t } = useTranslation();

  const isRestrictedRole =
    currentUser?.role === "user" || currentUser?.role === "user-multi";

  useEffect(() => {
    const fetchPasscodes = async () => {
      setLoading(true);
      try {
        const fetchedPasscodes = await passcodeService.current();
        setPasscodes(fetchedPasscodes.data);
      } finally {
        setLoading(false);
      }
    };

    fetchPasscodes();
  }, []);

  const tabs = [
    {
      key: "active",
      title: t("passcodes.tabActive"),
      content: loading ? (
        <Box align="center" pad="medium">
          <Spinner />
        </Box>
      ) : (
        <AccessList
          hotel={hotel}
          keys={passcodes}
          title={t("nav.passcodes")}
          collapsing={false}
          handleDeleteAccess={() => {}}
          handleEditAccess={() => {}}
          withGuestName
        />
      ),
    },
    ...(!isRestrictedRole && supportsMasterCodes(hotel, doors || [])
      ? [
          {
            key: "master",
            title: t("passcodes.tabMaster"),
            content: <MasterPasscodes />,
          },
        ]
      : []),
    {
      key: "door",
      title: t("passcodes.tabDoor"),
      content: <DoorPasscodes />,
    },
  ];

  return (
    <Box
      align="center"
      justify="start"
      pad="medium"
      gap="medium"
      flex="grow"
      margin={{ bottom: "300px" }}
      width="100%"
    >
      <Header
        align="center"
        direction="row"
        fill="horizontal"
        className="details-header"
      >
        <Heading level="2" className="heading">
          {t("passcodes.title")}
        </Heading>
      </Header>
      <Box width="100%">
        <CustomTabs tabs={tabs} />
      </Box>
    </Box>
  );
}
